const seekFromNow = (player, timeToAdd) => {
  player.currentTime(player.currentTime() + timeToAdd);
};

export default { seekFromNow };
